import Catalogue from '@/core/pages/Catalogue/Catalogue';

export default Catalogue;
